import { ResData, UserModels } from '../types';
import { API } from './axios';

export async function getUserMe(): Promise<ResData<UserModels.User>> {
  const response = await API.post<ResData>('/seller/user/me');

  return response.data;
}
export async function updateUserBankInfo(data: {
  phone: string;
  bank: {
    account: string;
    mfo: string;
  };
}): Promise<ResData> {
  const response = await API.post<ResData>('/seller/user/update', data);

  return response.data;
}
